export function isContain(arr, val) {
    return arr.includes(val);
}